import { createContext, useState, useMemo, FC, PropsWithChildren, useEffect } from "react";
import { useOktaAuth } from '@okta/okta-react';

export const AuthContext = createContext<{
    isAuthenticated: boolean;
    addAuthentication: (token: string) => void;
    clearAuthentication: () => void;
    authToken: string | null;
}>({
    isAuthenticated: false,
    addAuthentication: (token: string) => { throw new Error('AuthContext is not within scope.') },
    clearAuthentication: () => { throw new Error('AuthContext is not within scope.') },
    authToken: null
});

export const AuthContextProvider: FC<PropsWithChildren<{ mocked?: boolean }>> = ({ children, mocked }) => {
    const [ authToken, setAuthToken ] = useState<string | null>(mocked === true ? 'FAKE' : null);
    const isAuthenticated = useMemo(() => !!authToken, [ authToken ]);
    const { authState } = useOktaAuth();
    
    const addAuthentication = (token: string) => setAuthToken(token);
    const clearAuthentication = () => setAuthToken(null);

    useEffect(() => {
        if (authToken || !authState?.accessToken?.accessToken) {
            return
        }
        setAuthToken(authState?.accessToken?.accessToken);
    }, [authToken, authState]);

    return <AuthContext.Provider value={{ isAuthenticated, clearAuthentication, addAuthentication, authToken }}>
        { children }
    </AuthContext.Provider>
}